<vp-icon icon="warning" class="vp-icon-s-16-p-0-f-16 vp-icon-warning"></vp-icon>
<div class="error-message text-smaller">
    <ng-content></ng-content>
</div>
